<template>
  <div>
      <div ref="note">{{ content }} </div>
  </div>
</template>

<script>
export default {
    props: ['value'],
    data() {
        return {
            summernote: null,
            content: this.value,
            lastRange: null,
        }
    },
    mounted() {
        let vm = this
        this.summernote = $(this.$refs.note).summernote({
            placeholder: 'Insert text here ...',
            tabsize: 2,
            height: 200,
            toolbar: [
            ['style', ['style']],
            ['font', ['bold', 'underline', 'clear']],
            ['color', ['color']],
            ['para', ['ul', 'ol', 'paragraph']],
            ['table', ['table']],
            ['insert', ['link', 'picture']],
            ['view', ['fullscreen', 'help']]
            ],
        });


        this.summernote.on('summernote.change', function(we, contents, $editable) {
            vm.content = vm.summernote.summernote('code')
            vm.$emit('input', vm.content)

        });
    },
    methods: {
        updateEditor() {
            this.summernote.summernote('code', this.value)
        }
    }
}
</script>

<style>

</style>